var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import PaginationControls from './PaginationControls';
import { GroupList } from '../listGroup/GroupList';
import { GroupListItem } from '../listGroup/GroupListItem';
// Пагинация, состояние которой не нужно задавать из вне
var PaginationUncontrolled = /** @class */ (function (_super) {
    __extends(PaginationUncontrolled, _super);
    function PaginationUncontrolled(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            currentPage: _this.props.saveLSKeyId && JSON.parse(localStorage.getItem(_this.props.saveLSKeyId))
                ? JSON.parse(localStorage.getItem(_this.props.saveLSKeyId))
                : 1,
        };
        return _this;
    }
    PaginationUncontrolled.prototype.render = function () {
        var _this = this;
        var _a = this.props, itemsPerPage = _a.itemsPerPage, items = _a.items, showTopControls = _a.showTopControls, className = _a.className, classNameItem = _a.classNameItem, isNotDivideBorder = _a.isNotDivideBorder, classNameControls = _a.classNameControls, saveLSKeyId = _a.saveLSKeyId, buttonSize = _a.buttonSize;
        var currentPage = this.state.currentPage;
        var startIndex = itemsPerPage * (currentPage - 1);
        var lastIndex = startIndex + itemsPerPage;
        var itemsPage = items.slice(startIndex, lastIndex);
        var itemsJSX = itemsPage.map(function (item, index) { return (React.createElement(GroupListItem, { key: index, className: (classNameItem ? classNameItem : '') + (isNotDivideBorder ? ' border-0' : '') }, item)); });
        var controls = (React.createElement("div", { className: 'text-right ' + (classNameControls ? classNameControls : '') },
            React.createElement(PaginationControls, { buttonSize: buttonSize, itemsTotal: items.length, itemsPerPage: itemsPerPage, currentPage: currentPage, onChangePage: function (pageIndex) {
                    _this.setState({ currentPage: pageIndex });
                    if (saveLSKeyId) {
                        localStorage.setItem(saveLSKeyId, JSON.stringify(pageIndex));
                    }
                } })));
        return (React.createElement("div", { className: className },
            showTopControls && controls,
            React.createElement(GroupList, { flush: true, className: 'list-group-pagination' }, itemsJSX),
            controls));
    };
    return PaginationUncontrolled;
}(Component));
export default PaginationUncontrolled;
//# sourceMappingURL=PaginationUncontrolled.js.map